import {
  CreditCard,
  Settings,
  Shield,
  Briefcase,
  Award,
  HelpCircle,
  Bug,
  Lightbulb,
} from "lucide-react";

export interface TicketCategory {
  id: string;
  name: string;
  icon: any;
  description: string;
  priority: "low" | "medium" | "high";
  responseTime: string;
}

export interface SupportArticle {
  id: string;
  title: string;
  category: string;
  views: number;
}

export const ticketCategories: TicketCategory[] = [
  {
    id: "account",
    name: "Account Issues",
    icon: Settings,
    description: "Login problems, profile updates, verification",
    priority: "medium",
    responseTime: "24 hours",
  },
  {
    id: "payments",
    name: "Payments & Billing",
    icon: CreditCard,
    description: "Payment issues, withdrawals, tax documents",
    priority: "high",
    responseTime: "24 hours",
  },
  {
    id: "projects",
    name: "Projects & Tasks",
    icon: Briefcase,
    description: "Task issues, project access, guidelines",
    priority: "medium",
    responseTime: "24 hours",
  },
  {
    id: "technical",
    name: "Technical Problems",
    icon: Bug,
    description: "Bugs, errors, platform issues",
    priority: "high",
    responseTime: "24 hours",
  },
  {
    id: "security",
    name: "Security & Privacy",
    icon: Shield,
    description: "Account security, data concerns, suspicious activity",
    priority: "high",
    responseTime: "24 hours",
  },
  {
    id: "certifications",
    name: "Certifications & Skills",
    icon: Award,
    description: "Assessment issues, certification questions",
    priority: "low",
    responseTime: "24 hours",
  },
  {
    id: "feedback",
    name: "Feedback & Suggestions",
    icon: Lightbulb,
    description: "Feature requests, improvements, general feedback",
    priority: "low",
    responseTime: "24 hours",
  },
  {
    id: "other",
    name: "Other",
    icon: HelpCircle,
    description: "Anything else not covered above",
    priority: "medium",
    responseTime: "24 hours",
  },
];

export const priorityLevels = [
  {
    id: "low",
    name: "Low",
    description: "General inquiry, no urgency",
    color: "green",
  },
  {
    id: "medium",
    name: "Medium",
    description: "Issue affecting work, but not blocking",
    color: "yellow",
  },
  {
    id: "high",
    name: "High",
    description: "Urgent issue blocking work or payments",
    color: "orange",
  },
  {
    id: "critical",
    name: "Critical",
    description: "Security breach or account compromise",
    color: "red",
  },
];

export const popularArticles: SupportArticle[] = [
  {
    id: "1",
    title: "How to reset your password",
    category: "Account",
    views: 15420,
  },
  {
    id: "2",
    title: "Setting up payment methods",
    category: "Payments",
    views: 12350,
  },
  {
    id: "3",
    title: "Understanding task guidelines",
    category: "Projects",
    views: 9870,
  },
  {
    id: "4",
    title: "How earnings are calculated",
    category: "Payments",
    views: 8940,
  },
  {
    id: "5",
    title: "Enabling two-factor authentication",
    category: "Security",
    views: 7650,
  },
  {
    id: "6",
    title: "Withdrawing your earnings",
    category: "Payments",
    views: 7230,
  },
];

export const supportStats = {
  averageResponseTime: "24 hours",
  satisfactionRate: "98%",
  ticketsResolved: "50,000+",
  supportAgents: "24/7",
};
